import { Injectable, inject } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthService } from "@auth0/auth0-angular";
import { HOME_PATH } from "@sdk/lib/values/shared-paths";

@Injectable({
  providedIn: "root",
})
export class CanSeeLogInPageGuard implements CanActivate {
  private _router = inject(Router);
  private _auth = inject(AuthService);


  canActivate():
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this._auth.isAuthenticated$.pipe(
      take(1),
      map((isAuthenticated) => {
        if (isAuthenticated) {
          void this._router.navigate([`/${HOME_PATH}`]);
          return false;
        }
        return true;
      }),
    );
  }
}
